import { create } from 'zustand';
import type { DashboardData, DataSource } from '../data/types';

interface DashboardState {
  data: DashboardData | null;
  isLoading: boolean;
  error: string | null;
  lastFetched: number | null;
  refresh: (source: DataSource) => Promise<void>;
}

export const useDashboardStore = create<DashboardState>((set) => ({
  data: null,
  isLoading: false,
  error: null,
  lastFetched: null,
  refresh: async (source) => {
    set({ isLoading: true, error: null });
    try {
      const data = await source.load();
      set({ data, isLoading: false, lastFetched: Date.now() });
    } catch (err) {
      set({
        isLoading: false,
        error: err instanceof Error ? err.message : 'Failed to load sheet',
      });
    }
  },
}));
